import { envConfig } from '../../../../env';
import { Post } from '@/service/request/server';
import { EnumContentType } from '@/constant/enums';

const baseUrl = envConfig.formalServer + '/source/admin/';

function baseApi() {
    function chunkUploadFileInfo(data) {
        return Post(baseUrl + 'chunkUploadFiles', data, {
            headers: {
                'Content-Type': EnumContentType.formData
            }
        });
    }

    function checkAndMerge(data) {
        return Post(baseUrl + 'checkAndMerge', data, {
            headers: {
                'Content-Type': EnumContentType.formUrlencoded
            }
        });
    }

    return {
        chunkUploadFileInfo,
        checkAndMerge
    };
}

export const projectChunkFileApi = baseApi();

